import ResourceTyped from 'Resources/ResourceTyped';

import type { ExternalIntegrationWorkflowErrorHandling } from 'App/components/hooks/integrations/externalIntegrationTypes';

class ExternalIntegrationWorkflowErrorHandlingResource extends ResourceTyped<
	ExternalIntegrationWorkflowErrorHandling[]
> {
	constructor() {
		super('master/externalIntegrationWorkflowErrorHandlings', undefined, {
			notificationTitle: 'default.integration.workflowErrorHandling'
		});
	}

	async deleteMultiple(ids: number[], opts = {}) {
		// eslint-disable-next-line promise/catch-or-return
		return this._deleteRequest(ids, { ...opts, methodName: 'delete' });
	}
}

const resource = new ExternalIntegrationWorkflowErrorHandlingResource();

export default resource;
